import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { UsageScreenProvider } from 'marketplace-ui-tracking';
import { NavMarker } from 'react-rhumb';
import { Subscreens } from '../../constants/usage';
import { useCollectionQuery } from '../hooks/useCollectionQuery';
import { useSearchResultsQuery } from '../hooks/useSearchResultsQuery';
import { NoResults } from './NoResults';
import { ResultsGridWithSummary } from './ResultsGridWithSummary';
import { ResultsGridWithoutSummary } from './ResultsGridWithoutSummary';
import { useProductTypeSearchParam } from '../../hooks/useProductTypeSearchParams';
import { useGates } from '../../hooks/useGates';
import { jsx as _jsx } from "react/jsx-runtime";
export function ResultsGrid() {
  const gates = useGates();
  const productType = useProductTypeSearchParam();
  const {
    loading,
    data,
    error
  } = useSearchResultsQuery();
  const hasAi = (data === null || data === void 0 ? void 0 : data.result.aiAnswer) || (data === null || data === void 0 ? void 0 : data.result.aiRequestId);
  const hideAi = gates.solutionsSpringSpotlight && productType !== 'APP' && productType !== 'AGENT';
  if (loading) return /*#__PURE__*/_jsx(LoadingSpinner, {
    grow: true,
    size: "medium",
    marginBlockStart: "800"
  });
  if (error) return /*#__PURE__*/_jsx(ErrorMessage, {
    type: "badRequest"
  });
  if ((data === null || data === void 0 ? void 0 : data.result.cards.length) === 0) {
    return /*#__PURE__*/_jsx(SearchResultsNavMarker, {
      children: /*#__PURE__*/_jsx(UsageScreenProvider, {
        subscreen: Subscreens.NO_RESULTS,
        children: /*#__PURE__*/_jsx(NoResults, {})
      })
    });
  }
  return /*#__PURE__*/_jsx(SearchResultsNavMarker, {
    children: /*#__PURE__*/_jsx(UsageScreenProvider, {
      subscreen: Subscreens.RESULTS_GRID,
      children: hasAi && !hideAi ? /*#__PURE__*/_jsx(ResultsGridWithSummary, {}) : /*#__PURE__*/_jsx(ResultsGridWithoutSummary, {})
    })
  });
}
function SearchResultsNavMarker({
  children
}) {
  const isCollection = !!useCollectionQuery().data;
  return isCollection ? /*#__PURE__*/_jsx(NavMarker, {
    name: "COLLECTION_LOAD",
    children: children
  }) : /*#__PURE__*/_jsx(NavMarker, {
    name: "SEARCH_RESULTS_LOAD",
    children: children
  });
}